import React, { useState } from 'react';
import { FaQuestionCircle } from 'react-icons/fa';
import { FaSun, FaMoon } from 'react-icons/fa';

const questions = [
  {
    question: 'چگونه در موجیم ثبت‌نام کنم؟',
    answer: 'از طریق شماره موبایل خود در صفحه ورود ثبت‌نام کرده و با کد پیامک شده وارد شوید.',
  },
  {
    question: 'آیا برای استفاده از خدمات موجیم باید شماره موبایل خود را تایید کنم؟',
    answer: 'بله، برای ورود و احراز هویت نیاز به تایید شماره موبایل است.',
  },
  {
    question: 'چطور برنامه تمرینی دریافت کنم؟',
    answer: 'پس از ورود، وارد بخش "درخواست برنامه" شوید و فرم برنامه را تکمیل کنید.',
  },
  {
    question: 'برنامه‌های موجیم برای چه سطحی طراحی شده‌اند؟',
    answer: 'در فرم درخواست، سطح فعلی خود را مشخص می‌کنید و برنامه متناسب با آن طراحی می‌شود.',
  },
  {
    question: 'آیا برنامه تغذیه با شرایط خاص (مثل دیابت، گیاه‌خواری) هم سازگار است؟',
    answer: 'در فرم پرسشنامه می‌توانید وضعیت سلامتی و ترجیحات غذایی خود را ثبت کنید تا برنامه متناسب طراحی شود.',
  },
  {
    question: 'برنامه تغذیه شامل چه چیزهایی می‌شود؟',
    answer: 'شامل وعده‌های غذایی روزانه، مکمل‌ها و اطلاعات کالری و ماکروها است.',
  },
  {
    question: 'برنامه تغذیه شامل مکمل هم هست؟',
    answer: 'در صورت نیاز، مکمل‌هایی متناسب با هدف شما در برنامه گنجانده می‌شود.',
  },
  {
    question: 'هزینه دریافت برنامه چقدر است؟',
    answer: 'بسته به نوع برنامه، هزینه متفاوت است. در صفحه انتخاب برنامه قیمت‌ها مشخص شده‌اند.',
  },
  {
    question: 'اگر پرداخت انجام نشد چه کنم؟',
    answer: 'در صورت خطا در پرداخت، مجدداً از طریق صفحه پرداخت اقدام کنید یا با پشتیبانی تماس بگیرید.',
  },
  {
    question: 'چگونه برنامه را به صورت آفلاین ذخیره کنم؟',
    answer: 'در صفحه برنامه تمرینی یا تغذیه، می‌توانید فایل PDF آن را دانلود کرده و آفلاین استفاده کنید.',
  },
  {
    question: 'ویدیوهای حرکات را از کجا ببینم؟',
    answer: 'در هر حرکت تمرینی، ویدیوی آموزشی آن وجود دارد که به صورت آنلاین یا آفلاین قابل مشاهده است.',
  },
    {
    question: 'من قبلا پلن پرمیوم خریداری کردم و بیمه حوادث ورزشی صادر شده، باز هم در خرید بعدی پلن پرمیوم این بیمه نامه صادر خواهد شد؟',
    answer: 'خیر، بیمه حوادث ورزشی تنها در اولین خرید پلن پرمیوم صادر خواهد شد و در دفعات بعدی خرید پلن پرمیوم، هزینه به کارت شما برگشت داده می شود',
  },
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState(null);
      const [dark, setDark] = useState(true);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
     <div className={dark ? 'dark' : ''}>   
    <div className="min-h-screen bg-white dark:bg-[#0e1015] text-black dark:text-white font-vazir px-4 py-10 max-w-3xl mx-auto">
      <h1 className="text-2xl font-bold text-center mb-8">سوالات متداول</h1>

      <div className="space-y-4">
        {questions.map((q, index) => (
          <div
            key={index}
            className="bg-gray-100 dark:bg-[#1f1f2f] p-4 rounded-xl cursor-pointer shadow"
            onClick={() => toggle(index)}
          >
            <div className="flex items-center gap-2 font-semibold text-blue-700 dark:text-blue-300">
              <FaQuestionCircle /> {q.question}
            </div>
            {openIndex === index && (
              <p className="mt-2 text-sm text-gray-700 dark:text-gray-200">{q.answer}</p>
            )}
          </div>
        ))}
      </div>
    </div>
                  <button
          onClick={() => setDark(!dark)}
          className="fixed top-4 right-4 z-50 px-3 py-2 bg-gray-700 text-white rounded-full shadow-lg flex items-center justify-center"
        >
          {dark ? <FaSun className="text-yellow-400" /> : <FaMoon className="text-blue-500" />}
        </button>

    </div>
  );
}
